<template>
  <progress
    class="progressbar"
    :class="{ 'progressbar--disabled': disabled }"
    :value="value"
    :max="maxValue"
  />
</template>

<script setup>
defineProps({
  value: { type: Number, required: true },
  maxValue: { type: Number, default: 100 },
  disabled: { type: Boolean, default: false }
})
</script>

<style lang="scss" scoped>
.progressbar {
  appearance: none;
  display: block;
  border: none;
  width: 100%;
  height: 6px;
  margin: 6px 0;
  color: $color--primary; /* For IE10 */

  &::-webkit-progress-bar {
    background-color: rgba($dg, .1);
    border-radius: 4px;
  }

  &::-moz-progress-bar {
    border-radius: 4px;
    background-color: $color--primary;
  }

  &::-webkit-progress-value {
    border-radius: 4px;
    background-color: $color--primary;
  }

  &--disabled::-webkit-progress-value, &--disabled::-moz-progress-bar {
    background-color: rgba($dg, .4);
  }
}
</style>
